export default function ImportJsonPanel() {
  return (
    <div className="rounded-card border border-dashed border-background-300 bg-background-50/60 p-4 flex items-center justify-between gap-4 flex-wrap">
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center shrink-0">
          <i className="ri-file-upload-line text-primary-600 text-base" />
        </div>
        <div>
          <p className="text-sm font-medium text-foreground-800">Importar inspeção territorial (JSON do ChatGPT)</p>
          <p className="text-xs text-foreground-500 mt-0.5 max-w-lg">
            Envie o JSON gerado pelo Analista Territorial IA (metodologia FITA v1.0) para{" "}
            <code className="font-mono text-[11px] bg-background-100 px-1 py-0.5 rounded">
              POST /api/v1/territorial-inspections/import-json
            </code>
            . A importação por upload de arquivo nesta tela ainda está em preparação.
          </p>
        </div>
      </div>
      <button
        type="button"
        disabled
        title="Importação por upload ainda não disponível nesta tela"
        className="btn-outline text-xs px-3 py-2 opacity-60 cursor-not-allowed"
      >
        <i className="ri-upload-2-line" />
        Importar JSON
      </button>
    </div>
  );
}
